// extracted by mini-css-extract-plugin
export var wordContainer = "_q7-0";